import React, { Fragment, useState, useEffect, useCallback } from "react";
import MetaTags from "react-meta-tags";

import Loading from "../blocks/loading/Loading";
import HomeHeader from "../blocks/header/HomeHeader";
import Footer from "../blocks/footer/Footer";

import PageTitleHome from "../blocks/page-title/PageTitleHome";
import ServicesContent from "../blocks/services/ServicesContent";
import AboutUsPrimary from "../blocks/about/AboutUsPrimary";
import AboutUsMedia from "../blocks/about/AboutUsMedia";
import WhyUsContent from "../blocks/why-us/WhyUsContent";
import GalleryContent from "../blocks/gallery/GalleryContent";
import ReviewsContent from "../blocks/reviews/ReviewsContent";
import ClientsList from "../blocks/clients/ClientsList";
import NewsHome from "../blocks/news/NewsHome";
import ContactsContent from "../blocks/contacts/ContactsContent";
import ChatbotComponent from "./ChatbotComponent";

const Home = () => {
  const [isFixed, setIsFixed] = useState(false);

  const isInViewport = (element) => {
    if (!element) return false;
    const bounding = element.getBoundingClientRect();
    return window.screenTop - bounding.top > -20;
  };

  const handleScroll = useCallback(() => {
    const header = document.getElementById("header");
    const services = document.getElementById("services");

    if (isInViewport(services)) {
      document.body.classList.add("header-fixed");
      header.classList.add("animated", "slideInDown");
    } else {
      document.body.classList.remove("header-fixed");
      header.classList.remove("animated", "slideInDown");
    }

    setIsFixed(document.body.classList.contains("header-fixed"));
  }, []);

  useEffect(() => {
    document.body.classList.add(
      "home",
      "header-menu-true",
      "header-absolute-true",
      "header-fixed-true",
      "button-clicked-true"
    );

    window.addEventListener("scroll", handleScroll);

    return () => {
      document.body.classList.remove(
        "home",
        "header-menu-true",
        "header-absolute-true",
        "header-fixed-true",
        "button-clicked-true"
      );

      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  return (
    <Fragment>
      <MetaTags>
        <meta charSet="UTF-8" />
        <title>Ili Express</title>
        <meta httpEquiv="x-ua-compatible" content="ie=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="description" content="" />
        <meta name="keywords" content="" />
        <meta name="robots" content="index, follow, noodp" />
        <meta name="googlebot" content="index, follow" />
        <meta name="google" content="notranslate" />
        <meta name="format-detection" content="telephone=no" />
      </MetaTags>
      <Loading />
      <HomeHeader logoColor={isFixed ? "dark" : "light"} />
      <main id="main" className="site-main">
        <PageTitleHome />

        <section id="services" className="block spacer p-top-xl">
          <div className="wrapper">
            <div className="title">
              <h2>
                <a
                  title="Services"
                  className="transform-scale-h"
                  href={process.env.PUBLIC_URL + "/services"}
                >
                  Services
                </a>
              </h2>
            </div>

            <ServicesContent />
          </div>
        </section>

        <section id="about-us" className="block spacer p-top-xl">
          <div className="wrapper">
            <div className="row gutter-width-md">
              <AboutUsPrimary isHomepage={true} />

              <AboutUsMedia />
            </div>
          </div>
        </section>

        <section id="why-us" className="block spacer p-top-xl">
          <div className="bg-light spacer p-top-lg p-bottom-lg">
            <div className="wrapper">
              <div className="title">
                <h2>
                  <a
                    title="Why us"
                    className="transform-scale-h"
                    href={process.env.PUBLIC_URL + "/why-us"}
                  >
                    Why us
                  </a>
                </h2>
              </div>
            </div>

            <WhyUsContent />
          </div>
        </section>

        <section id="gallery" className="block spacer p-top-xl">
          <div className="wrapper">
            <div className="title">
              <h2>
                <a
                  title="Gallery"
                  className="transform-scale-h"
                  href={process.env.PUBLIC_URL + "/gallery"}
                >
                  Gallery
                </a>
              </h2>
            </div>
          </div>

          <GalleryContent />
        </section>

        <section id="reviews" className="block spacer p-top-xl">
          <div className="wrapper">
            <div className="title">
              <h2>
                <a
                  title="Customer reviews"
                  className="transform-scale-h"
                  href={process.env.PUBLIC_URL + "/reviews"}
                >
                  Customer reviews
                </a>
              </h2>
            </div>

            <ReviewsContent />
          </div>
        </section>

        <section id="clients" className="block spacer p-top-xl">
          <div className="wrapper">
            <div className="title">
              <h2>
                <a
                  title="Our clients"
                  className="transform-scale-h"
                  href={process.env.PUBLIC_URL + "/clients"}
                >
                  Our clients
                </a>
              </h2>
            </div>

            <ClientsList />
          </div>
        </section>

        <section id="news" className="block spacer p-top-xl">
          <div className="wrapper">
            <div className="title">
              <h2>
                <a
                  title="Current news"
                  className="transform-scale-h"
                  href={process.env.PUBLIC_URL + "/news"}
                >
                  Current news
                </a>
              </h2>
            </div>

            <NewsHome />
          </div>
        </section>

        <section id="contacts" className="block spacer p-top-xl">
          <div className="wrapper">
            <div className="title">
              <h2>
                <a
                  title="Contacts"
                  className="transform-scale-h"
                  href={process.env.PUBLIC_URL + "/contacts"}
                >
                  Contacts
                </a>
              </h2>
            </div>

            <ContactsContent />
          </div>
        </section>
      </main>
      <Footer />
      <ChatbotComponent />
    </Fragment>
  );
};

export default Home;
